import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getCountries } from '../routing/fetchingfunction/info/info.action'

import { formatCountry } from '../helpers'

const useCountries = () => {
  const dispatch = useDispatch()

  const { countries } = useSelector((state) => state.info)

  useEffect(() => {
    // Only dispatch getCountries if we don't have any countries data
    if (countries.length === 0) {
      dispatch(getCountries())
    }
    // Remove countries from dependencies, only run effect once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  const formattedCountries = formatCountry(countries).sort((a, b) => a.label.localeCompare(b.label))

  return {
    countries,
    formattedCountries,
  }
}

export default useCountries
